import React from 'react';
import TermsOfService from '../TermsOfService'; // Import the actual terms content
import coolyLogo from '../assets/coolyLogo.png'; // Optional: Add logo
import { Link } from 'react-router-dom';
import { ROUTES } from '../App';

const TermsOfServicePage = () => {
  return (
    <div className="min-h-screen bg-[#1E1E2D] text-white p-4 md:py-12 md:px-8">
      <div className="max-w-5xl mx-auto bg-[#2A2A3F] border border-purple-500/30 rounded-lg shadow-lg p-6 md:p-10 lg:p-12">
        <div className="flex justify-center mb-8">
           <Link to={ROUTES.HOME}>
             <img src={coolyLogo} alt="Coooly Logo" className="w-32 h-auto" />
           </Link>
        </div>
        <h1 className="text-3xl md:text-4xl font-bold text-purple-300 mb-8 text-center">Terms of Service</h1>
        
        {/* Apply custom styling directly to the container div */}
        <div className="text-gray-300">
          <style jsx>{`
            /* Custom injected styles for better spacing */
            .terms-content h2 {
              color: #d8b4fe;
              font-weight: 600;
              font-size: 1.5rem;
              margin-top: 2.5rem;
              margin-bottom: 1.25rem;
              padding-bottom: 0.5rem;
              border-bottom: 1px solid rgba(139, 92, 246, 0.3);
            }

            .terms-content h3 {
              color: #c4b5fd;
              font-weight: 500;
              font-size: 1.25rem;
              margin-top: 2rem;
              margin-bottom: 1rem;
            }
            
            .terms-content p {
              margin-bottom: 1.75rem;
              line-height: 1.7;
            }
            
            .terms-content ul {
              margin-top: 1.5rem;
              margin-bottom: 2rem;
              padding-left: 1.5rem;
              list-style-type: disc;
            }
            
            .terms-content ul li {
              margin-bottom: 1.5rem;
              padding-left: 0.5rem;
            }
            
            .terms-content ul li strong {
              color: #ddd6fe;
              font-weight: 600;
            }
            
            .terms-content a {
              color: #a78bfa;
              text-decoration: underline;
              transition: color 0.15s ease;
            }
            
            .terms-content a:hover {
              color: #c4b5fd;
            }
          `}</style>
          
          <div className="terms-content">
            <TermsOfService />
          </div>
        </div>
        
        <div className="mt-12 text-center">
          <Link to={ROUTES.HOME} className="text-purple-400 hover:text-purple-300 underline text-sm">
            &larr; Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TermsOfServicePage;
